import { Alert } from "@platform/design-system";

import { CircularProgressCentered } from "../../../../../../../components/CircularProgressCentered";

// ---------------------------------------------------------------------------
// Loading/empty gate — extracted to keep Quotes below the complexity limit
// ---------------------------------------------------------------------------

export const getQuotesLoadingState = ({
  isLoading,
  error,
  hasData,
  selectedCoverage,
}: {
  isLoading: boolean;
  error: Error | null | undefined;
  hasData: boolean;
  selectedCoverage: unknown;
}): React.ReactElement | null => {
  if (isLoading) {
    return <CircularProgressCentered />;
  }

  if (error) {
    return (
      <Alert severity="error">
        {error.message || "Failed to load quotes."}
      </Alert>
    );
  }

  if (!hasData || !selectedCoverage) {
    return <Alert severity="info">No coverages available for quotes.</Alert>;
  }

  return null;
};
